import { Edit, Eye, Trash } from "tabler-icons-react";

export const IndustryHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },

  //give full width to the question column

  {
    id: "industryName",
    numeric: false,
    disablePadding: true,
    label: "Industry Name",
  },
  {
    id: "industryDescription",
    numeric: false,
    disablePadding: true,
    label: "Description",
  },
  // {
  //   id: "state",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Status",
  // },
  // {
  //   id: "createdDate",
  //   date: true,
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Created Date",
  // },
  {
    id: "actions",
    view: <Eye />,
    edit: <Edit />,
    delete: <Trash />,
    numeric: false,
    label: "Actions",
  },
];
